import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import TwoFactorChallenge from "@/components/app/TwoFactorChallenge";
import { toast } from "sonner";

export default function MagicLinkCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const ran = useRef(false);
  const [challenge, setChallenge] = useState(null);

  const finishLogin = (u) => {
    setUser(u);
    const dest = u.role === "admin" ? "/admin"
      : u.role === "dealer" ? "/dealer"
      : "/dashboard";
    navigate(dest, { replace: true });
  };

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) { navigate("/login"); return; }
    api.get(`/auth/magic-link/verify?token=${encodeURIComponent(token)}`)
      .then((r) => {
        if (r.data?.requires_2fa) {
          setChallenge({ twofa_token: r.data.twofa_token, email: r.data.email });
          return;
        }
        finishLogin(r.data);
      })
      .catch(() => navigate("/login?error=magic_link_invalid"));
  }, [params, navigate, setUser]);

  if (challenge) {
    return (
      <div className="mx-auto max-w-md px-4 py-16" data-testid="page-magic-callback">
        <div className="border border-border p-8">
          <TwoFactorChallenge
            twofa_token={challenge.twofa_token}
            email={challenge.email}
            onVerified={(u) => { toast.success("Signed in"); finishLogin(u); }}
            onCancel={() => navigate("/login")}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[50vh] flex items-center justify-center" data-testid="page-magic-callback">
      <div className="text-muted-foreground font-mono-data text-sm">Signing you in…</div>
    </div>
  );
}
